export default __webpack_public_path__ + "static/media/35.e75d3697.png";